import {ARCHIVE_ACTION, ARCHIVE_DATA, ARCHIVE_POST_TYPE, ARCHIVE_POSTS_PER_PAGE} from '../constants'
import setTaxonomies from './set-taxonomies'
import setPagination from './set-pagination'
import setSearch from "./set-search";

export default function setData(archive, filterElement) {
    const postType = archive.getAttribute(ARCHIVE_POST_TYPE)
    const postsPerPage = archive.getAttribute(ARCHIVE_POSTS_PER_PAGE)

    let data = {
        action: ARCHIVE_ACTION,
        page_number: 1,
        posts_per_page: postsPerPage,
        post_type: postType,
        taxonomies: {}
    }

    if (archive.hasAttribute(ARCHIVE_DATA)) {
        data = JSON.parse(archive.getAttribute(ARCHIVE_DATA))
    }

    data = setTaxonomies(data, filterElement)
    data = setPagination(data, filterElement)
    data = setSearch(data, filterElement)

    archive.setAttribute(ARCHIVE_DATA, JSON.stringify(data))

    return data
}